export const displayAnswer = "12R45G78JW1B3G56789V1F3G567890";
